import React, { createContext, useContext, useEffect, useState } from "react";
const LabelContext = createContext();

export const LabelProvider = ({ children }) => {
    const [language, setLanguage] = useState("en"); // default language
    const [labels, setLabels] = useState({});

    // Get the correct labels from the JSON file
    useEffect(() => {
        const loadLabels = async () => {
            try {
                const module = await import(`../../I18n/${language}.json`);
                setLabels(module);
            } catch (error) {
                console.error(`Error loading ${language}.json`, error);
                setLabels({}); // fallback to empty if file not found
            }
        };
        loadLabels();
    }, [language]);


    return (
        <LabelContext.Provider value={{ labels, language, setLanguage }}>
            {children}
        </LabelContext.Provider>
    );
};

// Custom hook for easy access
export const useLabels = () => useContext(LabelContext);